<template>
  <div>
    <page-header :title="$t('scope.wecom_ext_groups_list')" :tabs="tabs" :current-tab.sync="currentTab" />
    <page-body>
      <keep-alive>
        <list v-if="currentTab === 'group'" :id="listId" />
      </keep-alive>
    </page-body>
  </div>
</template>

<script>
import List from './components/List'

export default {
  name: 'WecomExtGroupsIndex',
  components: {
    List,
  },
  data () {
    return {
      listId: 'WecomExtGroupsList',
      tabs: [
        {
          key: 'group',
          label: '群组',
        },
      ],
      currentTab: 'group',
    }
  },
}
</script>
